module.exports = __webpack_public_path__ + "img/sec1desk.14452976.png";